export type TiersRoleCode = "CLIENT" | "SUPPLIER" | "PARTNER" | "PROSPECT" | "PROVIDER" | "BENEFICIARY" | "OTHER";
export type TiersType = "PERSON" | "ORGANIZATION";

export interface TiersRole {
  id: number;
  role: TiersRoleCode;
  actif: boolean;
  depuis?: string | null;
  jusqu_au?: string | null;
}

export interface TiersContact {
  id: number;
  nom: string;
  fonction: string;
  email: string;
  telephone: string;
  whatsapp: string;
  principal: boolean;
  actif: boolean;
}

export interface TiersAdresse {
  id: number;
  type_adresse: "PRIMARY" | "BILLING" | "DELIVERY" | "OTHER";
  libelle: string;
  adresse: string;
  ville: string;
  region: string;
  pays: string;
  principal: boolean;
}

export interface Tiers {
  id: number;
  code: string;
  type_tiers: TiersType;
  nom: string;
  prenom: string;
  raison_sociale: string;
  nom_affichage: string;
  email: string;
  telephone: string;
  whatsapp: string;
  identifiant_fiscal: string;
  registre_commerce: string;
  actif: boolean;
  roles: TiersRole[];
  contacts: TiersContact[];
  adresses: TiersAdresse[];
  created_at: string;
  updated_at: string;
}

export const tiersRoleLabels: Record<TiersRoleCode, string> = {
  CLIENT: "Client",
  SUPPLIER: "Fournisseur",
  PARTNER: "Partenaire",
  PROSPECT: "Prospect",
  PROVIDER: "Prestataire",
  BENEFICIARY: "Bénéficiaire",
  OTHER: "Autre",
};

export const tiersRoles = Object.entries(tiersRoleLabels) as [TiersRoleCode, string][];
